import React from 'react';
import styled from 'styled-components';
import Image from 'next/image';
import useTranslation from 'next-translate/useTranslation';
import { useIsDesktop } from '../../style/constants';
import { Row, Col } from '../../VuexyDesign/atoms/_index';
import PricingCardButtonUpdated from './PricingCardButtonUpdated';
import DistributionButton from '../Distribution/DistributionButton';
import { Plan } from './index';

const DiscoverBenefits = ({ plan, type }: DiscoverBenefitsProps) => {
  const { t } = useTranslation('distributionLanding');
  const isDesktop = useIsDesktop();

  const getLablesData = () => {
    if (isDesktop) {
      return (
        <>
          <div className="mb-2">
            <div className="mt-2 text-left d-flex align-items-center w-100 flex-column flex-md-row justify-content-between ">
              {discoverBenefitsLables.slice(0, 3).map((item) => (
                <div
                  className="bg-white benefits-list d-flex align-items-center mr-2"
                  key={`benefits-${item}`}
                >
                  <span className="mr-1">
                    <Image
                      className="icon"
                      src="/static/images/pricing/right_icon.png"
                      alt="right icon logo"
                      width={25}
                      height={25}
                    />
                  </span>
                  <span>{t(item)}</span>
                </div>
              ))}
            </div>
            <div className="mt-2 text-left d-flex align-items-center w-100 flex-column flex-md-row  justify-content-between ">
              {discoverBenefitsLables.slice(3, 7).map((item) => (
                <div
                  className="bg-white benefits-list d-flex align-items-center mr-1"
                  key={`benefits-${item}`}
                >
                  <span className="mr-1">
                    <Image
                      className="icon"
                      src="/static/images/pricing/right_icon.png"
                      alt="right icon logo"
                      width={25}
                      height={25}
                    />
                  </span>
                  <span>{t(item)}</span>
                </div>
              ))}
            </div>
            <div className="mt-2 text-left d-flex align-items-center w-100 flex-column flex-md-row  justify-content-between ">
              {discoverBenefitsLables.slice(7).map((item) => (
                <div
                  className="bg-white benefits-list d-flex align-items-center mr-1"
                  key={`benefits-${item}`}
                >
                  <span className="mr-1">
                    <Image
                      className="icon"
                      src="/static/images/pricing/right_icon.png"
                      alt="right icon logo"
                      width={25}
                      height={25}
                    />
                  </span>
                  <span>{t(item)}</span>
                </div>
              ))}
            </div>
          </div>
        </>
      );
    }
    return (
      <>
        <div className="mb-2">
          <Row className="mt-2 text-left">
            {discoverBenefitsLables.map((item) => (
              <Col
                md={4}
                className="mt-1"
                key={`doscover-benefits-label-${item}`}
              >
                <div className="bg-white benefits-list d-flex align-items-center">
                  <span className="mr-1">
                    <Image
                      className="icon"
                      src="/static/images/pricing/right_icon.png"
                      alt="right icon logo"
                      width={25}
                      height={25}
                    />
                  </span>
                  <span>{t(item)}</span>
                </div>
              </Col>
            ))}
          </Row>
        </div>
      </>
    );
  };

  const getButtonForDiscover = () => (
    <>
      <div className="text-center mt-1">
        {plan ? (
          <>
            <PricingCardButtonUpdated type="GET_STARTED" plan={plan[0]} />
          </>
        ) : (
          <>
            <DistributionButton
              type="GRADIENT_FILLED"
              text={t('pricing:gettingStartedToday') as string}
            />
          </>
        )}
      </div>
    </>
  );

  return (
    <>
      {!type ? (
        <DiscoverBenefitsContainerWrapperWithPlan>
          <Banner className={` w-100  mb-5 `}>
            <div className="d-flex align-items-center flex-column">
              <h2 className="custom-heading-font-2 text-center">
                {t('pricing:discoverBenefits.discoverTitle') as string}
              </h2>
              <p
                className={`custom-font-text-regular-normal paragraph-color text-center mt-1 ${
                  isDesktop ? 'w-50' : 'w-100'
                }`}
              >
                {t('pricing:discoverBenefits.discoverSubTitle') as string}
              </p>

              {getLablesData()}
              {getButtonForDiscover()}
            </div>
          </Banner>
        </DiscoverBenefitsContainerWrapperWithPlan>
      ) : (
        <DiscoverBenefitsContainerWrapper>
          <Banner className={` w-100  mb-5 `}>
            <div className="d-flex align-items-center flex-column">
              <h2 className="custom-heading-font-2 text-center">
                {t('pricing:discoverBenefits.discoverTitle') as string}
              </h2>
              <p
                className={`custom-font-text-regular-normal paragraph-color  text-center mt-1 ${
                  isDesktop ? 'w-50' : 'w-100'
                }`}
              >
                {t('pricing:discoverBenefits.discoverSubTitle') as string}
              </p>
              {getLablesData()}
              {getButtonForDiscover()}
            </div>
          </Banner>
        </DiscoverBenefitsContainerWrapper>
      )}
    </>
  );
};

export default DiscoverBenefits;

const discoverBenefitsLables = [
  'pricing:discoverBenefits.distributeMusic',
  'pricing:discoverBenefits.revenueForm',
  'pricing:discoverBenefits.loyalties',
  'pricing:discoverBenefits.customLabel',
  'pricing:discoverBenefits.customReleaseDate',
  'pricing:discoverBenefits.itunesPricing',
  'pricing:discoverBenefits.realtimeStatistics',
  'pricing:discoverBenefits.noHiddenFees',
  'pricing:discoverBenefits.fullSupport',
  'pricing:discoverBenefits.promotionToAllUsers',
  'pricing:discoverBenefits.multipleArtists',
];
interface DiscoverBenefitsProps {
  plan?: Plan[];
  type?: string;
}

const Banner = styled.div`
  padding: 2rem;
  border: 1px solid transparent;
  border-radius: 20px;
  background: linear-gradient(135deg, #fcf3f8 0%, #f5f8fe 100%),
    linear-gradient(to left, #743ad5, #d53a9d);
  background-clip: padding-box, border-box;
  background-origin: padding-box, border-box;

  .benefits-list {
    padding: 1rem 1.1rem;
    font-size: 15px;
    border-radius: 10px;
  }
`;

const DiscoverBenefitsContainerWrapperWithPlan = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  margin: auto;
  padding: auto;
  width: 100%;
`;
const DiscoverBenefitsContainerWrapper = styled.div`
  position: absolute;
  bottom: 97px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  margin: auto;
  padding: auto;
  width: 100%;
`;
